import { combineReducers } from 'redux'
import { merge } from 'lodash'
import paginate from './paginate'
import custom from '../custom/reducers'
import Cat from '../entities/Cat'
import Grid from '../entities/Grid'
import Media from '../entities/Media'
import Menu from '../entities/Menu'
import Page from '../entities/Page'
import Post from '../entities/Post'
import Slug from '../entities/Slug'


/*
 * TODO:
 * - code, isFetching, timestamp refactoring
 * - set timestamp in one place, should set timestamp in reducer always (not in sagas)?
 */

// topMenu is fetched without pagination reducer, also it can't use entities.code, there is no other place where I can save response code
// FIXME: for better app quality, all codes, isFetcing and timestamp should be stored the same way
const menus = (state = { /*topMenu: { menuId: null, code: null, isFetching: false, timestamp: null }*/ }, action) => {
  if (action.response && action.response.menus) {
    return merge({}, state, action.response.menus)
  }

  return state
}

const entitiesDefaults = {
  items: { },
  code: null,
  isFetching: false,
  timestamp: null
}

const entities = (state = { cats: entitiesDefaults, grids: {}, media: {}, menus: {}, pages: {}, posts: {}, slugs: entitiesDefaults }, action) => {
  if (action.response && action.response.entities && Array.isArray(action.response.entities)) {
    const entities = { cats: { items: { } }, grids: {}, media: {}, menus: {}, pages: {}, posts: {}, slugs: { items: { } } }
    action.response.entities.forEach(entity => {

      // Cats and Slugs are fetched without pagination reducer, there is no other place where I can save response code
      // FIXME: for better app quality, all entities should have the same structure
      if (entity instanceof Cat) {
        entities.cats.items[entity.getId()] = entity
        entities.cats.code = action.response.code
        entities.cats.timestamp = + Date.now()
      }
      if (entity instanceof Slug) {
        entities.slugs.items[entity.getId()] = entity
        entities.slugs.code = action.response.code
        entities.slugs.timestamp = + Date.now()
      }
      if (entity instanceof Grid) entities.grid[entity.getId()] = entity
      if (entity instanceof Media) entities.media[entity.getId()] = entity
      if (entity instanceof Menu) entities.menus[entity.getId()] = entity
      if (entity instanceof Page) entities.pages[entity.getId()] = entity
      if (entity instanceof Post) entities.posts[entity.getId()] = entity
    })
    return merge({}, state, entities)
  }

  if (action.response && action.response.entities && !Array.isArray(action.response.entities)) {
    return merge({}, state, action.response.entities)
  }

  return state
}

const pagination = combineReducers({
  posts: paginate({
    mapActionToKey: action => action.target,
    types: [
      'FIND_POSTS_REQUEST',
      'FIND_POSTS_SUCCESS',
      'FIND_POSTS_FAILURE'
    ]
  })
})

const rootReducer = combineReducers({
  entities,
  menus,
  pagination,
  ...custom
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js